import CrudSection from "../components/CrudSection";
import { StatusTextBadge } from "../../../components/base/StatusTextBadge";
import type { CrudColumn, CrudField } from "../types";

// ===========================================================================
// Accesos temporales — secciones con datos de ejemplo que aún no pasan al API (las demás viven en ../screens, CC-CONSOLE #1593) (mock data, interactive in-session).
// Mirrors the landing "Accesos temporales" feature: QR / PIN / pase digital
// de un solo uso con vigencia, horario, zona y autorización previa.
// ===========================================================================

// --- Plantillas de invitación ----------------------------------------------
interface Plantilla extends Record<string, unknown> {
  id: string; nombre: string; tipoVisitante: string; duracion: string; zonas: string; autorizacion: string;
}
const plantillaColumns: CrudColumn<Plantilla>[] = [
  { key: "nombre", label: "Plantilla" },
  { key: "tipoVisitante", label: "Tipo de visitante" },
  { key: "duracion", label: "Duración" },
  { key: "zonas", label: "Zonas" },
  { key: "autorizacion", label: "Autorización", align: "center", render: (r) => <StatusTextBadge value={r.autorizacion} /> },
];
const plantillaFields: CrudField[] = [
  { key: "nombre", label: "Nombre", required: true, placeholder: "Visita familiar / Proveedor recurrente" },
  { key: "tipoVisitante", label: "Tipo de visitante", type: "select", required: true, options: [
    { value: "Visitante", label: "Visitante" }, { value: "Proveedor", label: "Proveedor" },
    { value: "Repartidor", label: "Repartidor" }, { value: "Evento", label: "Evento" },
  ] },
  { key: "duracion", label: "Duración", required: true, placeholder: "2 horas / 1 día / horario" },
  { key: "zonas", label: "Zonas permitidas", required: true, placeholder: "Lobby, Estacionamiento" },
  { key: "autorizacion", label: "Autorización previa", type: "select", defaultValue: "Requerida", options: [
    { value: "Requerida", label: "Requerida" }, { value: "Automática", label: "Automática" },
  ] },
];
const plantillaSeed: Plantilla[] = [
  { id: "pl1", nombre: "Visita familiar", tipoVisitante: "Visitante", duracion: "1 día", zonas: "Lobby, Amenidades", autorizacion: "Automática" },
  { id: "pl2", nombre: "Proveedor de servicio", tipoVisitante: "Proveedor", duracion: "Horario 08:00–15:00", zonas: "Acceso de servicio", autorizacion: "Requerida" },
  { id: "pl3", nombre: "Repartidor", tipoVisitante: "Repartidor", duracion: "30 minutos", zonas: "Recepción", autorizacion: "Automática" },
  { id: "pl4", nombre: "Invitados a evento", tipoVisitante: "Evento", duracion: "Por evento", zonas: "Salón de usos", autorizacion: "Requerida" },
];
export const PlantillasSection = () => (
  <CrudSection<Plantilla> title="Plantillas de invitación" subtitle="Configura pases reutilizables por tipo de visitante"
    icon="ri-file-copy-2-line" columns={plantillaColumns} fields={plantillaFields} seed={plantillaSeed} searchKey="nombre" />
);

// --- Autorizaciones previas ------------------------------------------------
interface Autorizacion extends Record<string, unknown> {
  id: string; solicitante: string; anfitrion: string; zona: string; solicitado: string; estado: string;
}
const autorizacionColumns: CrudColumn<Autorizacion>[] = [
  { key: "solicitante", label: "Solicitante" },
  { key: "anfitrion", label: "Anfitrión" },
  { key: "zona", label: "Zona" },
  { key: "solicitado", label: "Solicitado" },
  { key: "estado", label: "Estado", align: "center", render: (r) => <StatusTextBadge value={r.estado} /> },
];
const autorizacionFields: CrudField[] = [
  { key: "solicitante", label: "Solicitante", required: true, placeholder: "Nombre del visitante" },
  { key: "anfitrion", label: "Anfitrión", required: true, placeholder: "Residente o administrador" },
  { key: "zona", label: "Zona", required: true, placeholder: "Lobby / Estacionamiento" },
  { key: "solicitado", label: "Fecha solicitada", type: "date", required: true },
  { key: "estado", label: "Estado", type: "select", defaultValue: "Pendiente", options: [
    { value: "Pendiente", label: "Pendiente" }, { value: "Aprobada", label: "Aprobada" }, { value: "Rechazada", label: "Rechazada" },
  ] },
];
const autorizacionSeed: Autorizacion[] = [
  { id: "a1", solicitante: "Proveedor Limpieza", anfitrion: "Admin", zona: "Acceso de servicio", solicitado: "2026-06-08", estado: "Pendiente" },
  { id: "a2", solicitante: "Visita Depto 402", anfitrion: "Carlos Ruiz", zona: "Lobby", solicitado: "2026-06-08", estado: "Aprobada" },
  { id: "a3", solicitante: "Repartidor", anfitrion: "Casa 12", zona: "Recepción", solicitado: "2026-06-07", estado: "Rechazada" },
];
export const AutorizacionesSection = () => (
  <CrudSection<Autorizacion> title="Autorizaciones previas" subtitle="Aprobaciones del residente o administrador antes de activar el acceso"
    icon="ri-checkbox-circle-line" columns={autorizacionColumns} fields={autorizacionFields} seed={autorizacionSeed} searchKey="solicitante" />
);
